// extracted by mini-css-extract-plugin
export default {"itemText":"NavbarItems_itemText__V0ymE","selectedItem":"NavbarItems_selectedItem__jhb0j","icon":"NavbarItems_icon__gmZz5","notSelectedItem":"NavbarItems_notSelectedItem__kd+z6"};